function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="15" height="11" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M.483 0h14.034c.266 0 .483.234.483.521V2.14H0V.521C0 .234.217 0 .483 0zm9.42 6.466h3.546v2.979H9.903v-2.98zM15 3.983v6.495c0 .288-.217.522-.483.522H.483C.217 11 0 10.766 0 10.478V3.983h15z" fill="#4F5EA3" fillRule="evenodd" /></svg>;
});